module.exports = __webpack_public_path__ + "img/mercedes-eqc-page-gal-5.be0476b8.jpg";